<template>
  <v-snackbar
    v-model="snackbar"
    right
    top
    :timeout="8000"
    :color="color"
  >
    {{ text }}
    <v-btn
      icon
      @click="snackbar = false"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  props: ['text', 'color'],
  data: () => ({
    snackbar: false
  }),
  watch: {
    text () {
      this.snackbar = !!this.text
    }
  }
}
</script>
